import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_URL+'/PromoCode';
// Create axios instance with default config
const api = axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add request interceptor for auth token if needed
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('authToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor for error handling
api.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('API Error:', error);
    return Promise.reject(error);
  }
);

export const promoCodeService = {
  // Get paginated promo codes
  getPromoCodes: async (pageNumber = 1, size = 10, searchTerms = '') => {
    try {
      const response = await api.get('/Pagination', {
        params: {
          pageNumber,
          size,
          searchTerms
        }
      });
      
      // Backend returns: { list: [], page: 1, pageSize: 10, total: 0, maxPage: 0 }
      const data = response.data;
      
      return {
        data: data.list || [], // The actual promo codes array
        totalItems: data.total || 0,
        totalPages: data.maxPage || 0,
        currentPage: data.page || 1,
        pageSize: data.pageSize || size
      };
    } catch (error) {
      console.error('Error fetching promo codes:', error);
      throw new Error(`Failed to fetch promo codes: ${error.message}`);
    }
  },

  // Get single promo code by ID
  getPromoCode: async (id) => {
    try {
      const response = await api.get(`/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching promo code:', error);
      throw new Error(`Failed to fetch promo code: ${error.message}`);
    }
  },

  // Create new promo code
  createPromoCode: async (promoCodeData) => {
    try {
      const payload = {
        id: 0,
        updatedDatetime: new Date().toISOString(),
        code: promoCodeData.code,
        quantite: Number(promoCodeData.quantite),
        montant: Number(promoCodeData.montant),
        active: promoCodeData.active
      };
      
      const response = await api.post('', payload);
      return response.data;
    } catch (error) {
      console.error('Error creating promo code:', error);
      throw new Error(`Failed to create promo code: ${error.message}`);
    }
  },

  // Update existing promo code
  updatePromoCode: async (id, promoCodeData) => {
    try {
      const payload = {
        id: Number(id),
        updatedDatetime: new Date().toISOString(),
        code: promoCodeData.code,
        quantite: Number(promoCodeData.quantite),
        montant: Number(promoCodeData.montant),
        active: promoCodeData.active
      };
      
      const response = await api.put('', payload);
      return response.data;
    } catch (error) {
      console.error('Error updating promo code:', error);
      throw new Error(`Failed to update promo code: ${error.message}`);
    }
  },

  // Delete promo code
  deletePromoCode: async (id) => {
    try {
      const response = await api.delete(`/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting promo code:', error);
      throw new Error(`Failed to delete promo code: ${error.message}`);
    }
  },

  // Bulk delete promo codes
  bulkDeletePromoCodes: async (ids) => {
    try {
      const deletePromises = ids.map(id => api.delete(`/${id}`));
      await Promise.all(deletePromises);
      return { success: true };
    } catch (error) {
      console.error('Error bulk deleting promo codes:', error);
      throw new Error(`Failed to delete promo codes: ${error.message}`);
    }
  }
  
};